export default __webpack_public_path__ + "static/media/peknieciapo.647fcb3d.jpeg";